import {Component, OnInit} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../core/service/auth.service";
import {UserProfileService} from "../../service/user-profile.service";
import {Router} from "@angular/router";
import {AppMessageService} from "../../../core/service/app-message.service";
import {MessageHelper} from "../../../core/helper/message-helper";


@Component({
  selector: 'update-email',
  templateUrl: './update-email.component.html',
  styleUrls: ['update-email.component.scss']
})
export class UpdateEmailComponent extends CoreComponent implements OnInit {

  formGroup: FormGroup | undefined;

  constructor(protected userProfileService: UserProfileService,
              protected formBuilder: FormBuilder,
              protected router: Router,
              protected messageService: AppMessageService,
              protected authService: AuthService) {
    super();
  }


  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }


  refreshComponent() {
    this.buildFormGroup();
    this.initialized = true;
  }

  buildFormGroup() {
    this.formGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    this.formGroup.patchValue({
      email: this.userProfileService.email
    });

  }

  updateEmail() {

    this.busy = true;
    const email = this.formGroup?.get('email')?.value;
    const password = this.formGroup?.get('password')?.value;

    this.authService.updateEmail(email, password).subscribe(res => {
        MessageHelper.showSuccessMessage(res.data as string, this.messageService);
        this.router.navigate(['ds/us/profile']);
        this.busy = false;
      },
      error => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService);
        this.busy = false;
      }
    );
  }

}
